import React from 'react';
import DynamicFormViewer from '../../Components/FormData/DynamicFormViewer';
import {
  getAllFindYourQuestions,
  deleteFindYourQuestion,
  updateFindYourQuestionById,
} from '../../Redux/Store/API/FormsData/FindYourQuestions';

export default function QuestionsFormData() {
  const headers = [
    { key: 'firstname', label: 'First Name' },
    { key: 'lastname', label: 'Last Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'subject', label: 'Subject' },
    { key: 'query', label: 'Question / Query' },
    { key: 'sourcePage', label: 'Source Page', render: (v) => v || '—' },
  ];

  return (
    <DynamicFormViewer
      title="User Questions & Inquiries"
      headers={headers}
      fetchAction={getAllFindYourQuestions}
      deleteAction={deleteFindYourQuestion}
      updateAction={updateFindYourQuestionById}
      stateSliceName="findYourQuestions"
      dataKey="getallFindYourQuestions"
    />
  );
}
